import { render, staticRenderFns } from "./InputSelecionaBanco.vue?vue&type=template&id=1ef737de"
import script from "./InputSelecionaBanco.vue?vue&type=script&lang=js"
export * from "./InputSelecionaBanco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports